export const actionTypes = {
  FOCUSED: 'FOCUSED' as const,
  BLURRED: 'BLURRED' as const,
  PATTERN_CHANGED: 'PATTERN_CHANGED' as const,
  MATCH_SELECTED: 'MATCH_SELECTED' as const,
  MATCH_PRESELECTED: 'MATCH_PRESELECTED' as const,
  KEY_PRESSED: 'KEY_PRESSED' as const,
} as const;

export type ActionTypes = typeof actionTypes;
